/**
 * t215u: the one horizontal chip row for the phone. It only slides sideways: overflow-y hidden, a fixed height (chip +
 * focus ring, with that room as padding inside the scroller, so nothing is clipped and there is no inner vertical
 * scroll), no wrapping, touch-action pan-x, horizontal overscroll contained, no scrollbar.
 */
import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

/** Chips are 32px (h-8); 2px of ring room above and below. */
export const CHIP_ROW_HEIGHT = 36;

export function ChipRow({ children, className, bleed, height = CHIP_ROW_HEIGHT, ...rest }: HTMLAttributes<HTMLDivElement> & { children: ReactNode; bleed?: boolean; height?: number }) {
  return (
    <div {...rest} data-chip-row
      className={clsx('no-scrollbar flex flex-nowrap items-center gap-1.5 overflow-x-auto overflow-y-hidden whitespace-nowrap py-0.5 [overscroll-behavior-x:contain] [touch-action:pan-x] [&>*]:shrink-0',
        bleed && '-mx-4 px-4', className)}
      style={{ height, ...rest.style }}>
      {children}
    </div>
  );
}
